import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    // Default scroll to top when navigating between pages
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
